import NewsPage from './newsPage';
import Vue from 'vue';
const mountPoint = document.querySelector('#vue-news');
new Vue({
    el: mountPoint,
    render(createElement) {
        return createElement(NewsPage, {
            props: {
                paths: JSON.parse(mountPoint.dataset.paths),
                newsFeeds: JSON.parse(mountPoint.dataset.newsfeeds),
            },
        });
    },
}).$mount();
